/** Gemini LLM adapter — STUB. Implements LLMPort. */
export function createGeminiLLM() {
  return {
    async status() { return { vendor: "gemini", model: "3-flash", status: "not_configured" }; },
    async generatePlay() { throw new Error("GEMINI_LLM_NOT_IMPLEMENTED"); },
    async regeneratePlay() { throw new Error("GEMINI_LLM_NOT_IMPLEMENTED"); },
  };
}
